import { render, staticRenderFns } from "./ResolveDisputeForm.vue?vue&type=template&id=4a36d159&scoped=true"
import script from "./ResolveDisputeForm.vue?vue&type=script&lang=js"
export * from "./ResolveDisputeForm.vue?vue&type=script&lang=js"
import style0 from "./ResolveDisputeForm.vue?vue&type=style&index=0&id=4a36d159&prod&scoped=true&lang=css"
import style1 from "./ResolveDisputeForm.vue?vue&type=style&index=1&id=4a36d159&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36d159",
  null
  
)

export default component.exports